import React from 'react';
import { useParams, Navigate } from 'react-router-dom';

const FILES = {
  'anil-kumar': '/newsletters/anil-kumar.html',
  'sai-santosh': '/newsletters/sai-santosh.html',
  'rajesh-gopakumar': '/newsletters/rajesh-gopakumar.html',
};

const NewsletterReader = () => {
  const { slug } = useParams();
  const src = FILES[slug];

  if (!src) {
    return <Navigate to="/newsletters" replace />;
  }

  return (
    <iframe
      title={`Science Unlocked Newsletter — ${slug}`}
      src={src}
      data-testid="newsletter-reader-iframe"
      style={{
        position: 'fixed',
        inset: 0,
        width: '100%',
        height: '100%',
        border: 'none',
      }}
    />
  );
};

export default NewsletterReader;
